/* @flow */
import React from 'react';
import Box from 'components/Box';
import Link from 'components/Link';
import MailTo from 'components/MailTo';
import BoxBody from 'components/BoxBody';

import './styles/IntegrationSettingsNotFound.scss';

class IntegrationSettingsNotFound extends React.Component<{}, {}> {
  render() {
    return (
      <div className="IntegrationSettingsNotFound">
        <Box size="small">
          <BoxBody>
            <div>
              <div>Want to configure an integration with Remind? </div>
              Check out{' '}
              <Link target="_blank" href="https://www.remind.com/partners">
                remind.com/partners
              </Link>
              , and email <MailTo to="partners@remindhq.com">partners@remindhq.com</MailTo> if you
              are ready to get started.
            </div>
          </BoxBody>
        </Box>
      </div>
    );
  }
}

export default IntegrationSettingsNotFound;
